import { List, Datagrid, TextField, EditButton, FieldProps, ShowButton, Filter, ReferenceInput, SelectInput, TextInput } from "react-admin";
import ClearFiltersOnRouteChange from "../../common/ClearFiltersOnRouteChange";
import FormattedDateTimeField from "../../common/FormattedDateTimeField";
import PermissionBasedActions from "../../common/PermissionBasedActionsButton";
import useIsPermission from "../../hooks/useIsPermission";
import { SoftDeleteWithDialogAction } from "../../common/SoftDeleteWithDialogAction";
import ConfirmDeleteButton from "../../common/ConfirmDeleteButton";

const Actions = (props: FieldProps<any>) => {
  const { isDeletable, isUpdatable } = useIsPermission("ACTIVATION_CODES");
  return (
    <div className={"flex gap-2"}>
      {isUpdatable &&
        <EditButton />
      }
      {isDeletable &&
        <ConfirmDeleteButton />
      }
    </div>
  );
};


const ListFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search Code" source="code" alwaysOn />
  </Filter>
);

const ActivationCodesList = () => {
  const { isWritable } = useIsPermission("ACTIVATION_CODES");

  return (
    <List
      resource="activation-codes"
      filters={<ListFilter />}
      actions={<PermissionBasedActions isWritable={isWritable} />}
    >
      <ClearFiltersOnRouteChange />
      <Datagrid>
        <TextField source="title" />
        <TextField source="code" />
        <TextField source="secret" />
        <FormattedDateTimeField source="createdAt" />
        <Actions />
      </Datagrid>
    </List>
  );
};

export default ActivationCodesList;